import { Stack, Typography } from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'

/**
 * Section intro: short lead and lighter detail line (no separate section title).
 *
 * @param {{
 *   headingId?: string,
 *   lines: readonly [string, string] | string[],
 * }} props
 */
export default function SettingsSectionIntro({ headingId, lines }) {
  if (!lines?.[0] || !lines?.[1]) return null

  const [lead, detail] = lines

  return (
    <Stack className={shared.settingsSectionIntro}>
      <Typography id={headingId} component="p" className={shared.settingsSectionIntroLead}>
        {lead}
      </Typography>
      <Typography component="p" className={shared.settingsSectionIntroDetail}>
        {detail}
      </Typography>
    </Stack>
  )
}
